export const WILLING_ERRORS = {
    FETCH_WILLING_DATA_ERROR: "Error fetching willing data:",
}

export const WILLING_TABS = {
    TEXTS: "Texts",
    EMAILS: "Emails",
};


